import { ComponentType, lazy } from "react";
export const Dashboard = lazy(() => import("@/B2C/features/dashboard/dashboardIndex"));
export const Clients = lazy(() => import("@/B2C/features/clients/ClientPage"));
export const Quotes = lazy(() => import("@/B2C/features/quotes/QuotesPage"));
export const PipeLine = lazy(() => import("@/B2C/features/Pipeline/PipelinePage"));
export const PoliciesPage = lazy(() => import("@/B2C/features/Policies/PoliciesPage"));
export const CommissionLedgerPage = lazy(
  () => import("@/B2C/features/CommissionLedger/CommissionLedgerPage")
);
export const InvoicesPage = lazy(() => import("@/B2C/features/Invoices/InvoicesPage"));
export const SettingsPage = lazy(() => import("@/B2C/features/setting/settingPage"));
export const LovableHub = lazy(() => import("@/B2C/features/lovable/LovableHubPage"));
export const Insurer = lazy(() => import("@/ADMIN/feature/insurar/InsurarPage"));
export const ApiConfiguration = lazy(() => import("@/ADMIN/feature/apiConfig/ApiConFigPage"));
export const ThirdPartyApi = lazy(() => import("@/ADMIN/feature/thirdPartyApi/ThirdPartyApiPage"));
export const Logs = lazy(() => import("@/ADMIN/feature/Logs-monitoring/LogPage"));
export const Channels = lazy(() => import("@/ADMIN/feature/Channels/ChannelsPage"));
export const ReviewQueuePage = lazy(() => import("@/ADMIN/feature/ReviewQueue/ReviewQueuePage"));

export const SECURE_ELEMENT_REGISTRY: Record<string, ComponentType<any>> = {
  Dashboard,
  Clients,
  Quotes,
  PipeLine,
  PoliciesPage,
  CommissionLedgerPage,
  InvoicesPage,
  Settings: SettingsPage,
  LovableHub,
  Insurer,
  ApiConfiguration,
  ThirdPartyApi,
  Logs,
  Channels,
  ReviewQueuePage,
  // Every Lovable-hosted iframe page the backend may hand out — different module, same embed.
  CommissionDashboard: LovableHub,
  IRDAICompliancePage: LovableHub,
  Reconciliation: LovableHub,
  Variances: LovableHub,
  Tds: LovableHub,
  Reports: LovableHub,
  Configuration: LovableHub,
  Cases: LovableHub,
  Claims: LovableHub,
};

export const NESTED_ROUTING_ELEMENTS = new Set<ComponentType<any>>([LovableHub]);

export const MODULE_NAME_ELEMENT_FALLBACK: Record<string, ComponentType<any>> = {
  "commission-dashboard": LovableHub,
  "irdai-compliance": LovableHub,
  reconciliation: LovableHub,
  variances: LovableHub,
  tds: LovableHub,
  reports: LovableHub,
  configuration: LovableHub,
  case: LovableHub,
  claims: LovableHub,
};
